'use client';

import {
  getCategorias,
  // getDestaques,
  listarCombos,
  listarProdutos,
} from '@/services/marketplaceService';
import { Categoria } from '@/types/categoria';
import { Combo } from '@/types/combo';
// import { Destaque } from '@/types/destaque';
import { Produto } from '@/types/produto';
import {
  createContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
} from 'react';

/* Banners destaques HOME */

// Comentario so para subir
import banner_destaque_paramount_mobile from '@/assets/banner_destaque_principal_home_mobile_paramount_plus.jpg';
import banner_destaque_paramount from '@/assets/banner_destaque_principal_home_paramount_plus.png';

import banner_destaque_imovision_mobile from '@/assets/banner_destaque_principal_home_mobile_imovision.webp';
import banner_destaque_imovision from '@/assets/banner_destaque_principal_home_imovision.webp';

import banner_destaque_hbo_max_mobile from '@/assets/banner_destaque_principal_home_mobile_hbo_max.jpg';
import banner_destaque_hbo_max from '@/assets/banner_destaque_principal_home_hbo_max.jpg';

/* Banners promocional | DESKTOP */
// import banner_imovision from '@/assets/banner_imovision.png';
// import banner_disney_plus from '@/assets/banner_disney_plus.png';
// import banner_paramount from '@/assets/banner_paramount_plus.png';
// import banner_deezer from 'styles__ContainerTextosCarteira@/assets/banner_deezer.png';
// import banner_hbo from '@/assets/banner_hbo_max.jpg';
// import banner_gift_card_mobile from '@/assets/banner_gift_card_mobile.png';
import banner_promocional_hbo_max from '@/assets/banner_promocional_hbo_max.jpg';
// import banner_promocional_disney from '@/assets/banner_promocional_disney.png';
import banner_promocional_disney_cara_focinho from '@/assets/banner_promocional_disney_cara_focinho.png';

/*  Banners promocionais | MOBILE */
import banner_promocional_paramount from '@/assets/banner_promocional_paramount.png';
import banner_promocional_bottom_hbo_max from '@/assets/banner_promocional_bottom_hbo_max.jpg';
// import banner_promocional_game_pass from '@/assets/banner_promocional_game_pass.png';

import { MotivoDenunciaResenha } from '@/types/resenha';
import { listarTiposDenunciaResenha } from '@/services/resenhaService';
import { listarPlaylistsUsuario } from '@/services/playlistsService';
import { ArgumentosListarPlaylistsUsuario } from '@/services/types/playlists';
import { Favoritos, Playlist, VerDepois } from '@/types/playlists';
import { GaleriaImagem } from '@/components/molecules/Galeria';
import {
  listarConteudosEmAltaStreaming,
  listarFilmesEmCartaz,
} from '@/services/conteudoService';
import { ConteudoRecomendacao } from '@/services/types/recomendacao';
import { DestaqueCarouselItem } from '@/components/organisms/CarouselDestaques';
import { useSession } from 'next-auth/react';
import { Destaque } from '@/types/destaque';

interface HomePageDataType {
  categorias: Array<Categoria> | null;
  destaquesMobile: Array<Destaque>;
  destaquesDesktop: Array<GaleriaImagem>;
  produtos: Array<Produto> | null;
  combos: Array<Combo> | null;
  assinaturas: Array<Produto> | null;
  carregandoAssinaturas: boolean;
  tiposDenunciaResenha: MotivoDenunciaResenha[] | null;
  setCategorias: Dispatch<SetStateAction<Categoria[] | null>>;
  // setDestaques: Dispatch<SetStateAction<Destaque[] | null>>;
  setProdutos: Dispatch<SetStateAction<Produto[] | null>>;
  setCombos: Dispatch<SetStateAction<Combo[] | null>>;
  recuperarCategorias: () => void;
  setAssinaturas: Dispatch<SetStateAction<Produto[] | null>>;
  recuperarProdutos: () => void;
  recuperarCombos: () => void;
  recuperarAssinaturas: () => void;
  recuperarTiposDenunciaResenha: () => void;
  recuperarListasUsuario: (
    props: ArgumentosListarPlaylistsUsuario,
  ) => Promise<void>;
  categoriaTodos: Categoria;
  playlistsUsuario: Playlist[] | null;
  favoritos: Favoritos[] | null;
  verDepois: VerDepois[] | null;
  loadingListasUsuario: boolean;
  recuperarEmAltaStreaming: () => void;
  emAltaStreaming: Array<ConteudoRecomendacao> | null;
  carregandoEmAltaStreaming: boolean;
  recuperarFilmesEmCartaz: () => void;
  filmesEmCartaz: Array<ConteudoRecomendacao> | null;
  carregandoFilmesEmCartaz: boolean;
  bannersCarousel: Array<DestaqueCarouselItem>;
  bannersPromocionaisDesktop: Array<GaleriaImagem>;
}

export const HomePageDataContext = createContext<HomePageDataType | undefined>(
  undefined,
);

export const HomePageDataProvider = ({ children }: { children: ReactNode }) => {
  const [categorias, setCategorias] = useState<Array<Categoria> | null>(null);
  const [bannersCarousel] = useState<DestaqueCarouselItem[]>([
    {
      imagemDesktop: banner_destaque_hbo_max,
      imagemMobile: banner_destaque_hbo_max_mobile,
      // linkDesktop: 'https://www.chippu.com.br/assinatura/hbo-max',
      // linkMobile: 'https://www.chippu.com.br/assinatura/hbo-max',
      linkDesktop:
        'https://www.chippu.com.br/assinatura/hbo-max?utm_source=Site-Chippu&utm_medium=Site-Chippu&utm_campaign=hbomax-regular&utm_content=banner-home',
      linkMobile:
        'https://www.chippu.com.br/assinatura/hbo-max?utm_source=Site-Chippu&utm_medium=Site-Chippu&utm_campaign=hbomax-regular&utm_content=banner-home',
    },
    // {
    //   imagemDesktop: banner_destaque_principal_home_desktop_disney_zootopia,
    //   imagemMobile: banner_destaque_principal_home_mobile_disney_zootopia,
    //   linkDesktop:
    //     'https://disney-plus.chippu.com.br/?utm_source=Site-Chippu&utm_medium=Site-Chippu&utm_campaign=disney-marco&utm_content=banner-home',
    //   linkMobile:
    //     'https://disney-plus.chippu.com.br/?utm_source=Site-Chippu&utm_medium=Site-Chippu&utm_campaign=disney-marco&utm_content=banner-home',
    // },
    // {
    //   imagemDesktop: banner_destaque_principal_home_desktop_disney_zootopia,
    //   imagemMobile: banner_destaque_principal_home_mobile_disney_zootopia,
    //   linkDesktop:
    //     'https://disney-plus.chippu.com.br/?utm_source=Site-Chippu&utm_medium=Site-Chippu&utm_campaign=disney-marco&utm_content=banner-home',
    //   linkMobile:
    //     'https://disney-plus.chippu.com.br/?utm_source=Site-Chippu&utm_medium=Site-Chippu&utm_campaign=disney-marco&utm_content=banner-home',
    // },
    // {
    //   imagemDesktop: banner_destaque_nfl_game_pass_dazn,
    //   imagemMobile: banner_destaque_nfl_game_pass_dazn_mobile,
    //   linkDesktop:
    //     'https://www.chippu.com.br/produto/nfl-game-pass---dazn?utm_source=Destaque+Principal+NFL+Game+Pass+Daz+Chippu+Site&utm_medium=Site+Chippu',
    //   linkMobile:
    //     'https://www.chippu.com.br/produto/nfl-game-pass---dazn?utm_source=Destaque+Principal+NFL+Game+Pass+Daz+Chippu+Site&utm_medium=Site+Chippu',
    // },
    {
      imagemDesktop: banner_destaque_imovision,
      imagemMobile: banner_destaque_imovision_mobile,
      linkDesktop: 'https://www.chippu.com.br/assinatura/imovision-1',
      linkMobile: 'https://www.chippu.com.br/assinatura/imovision-1',
    },
    {
      imagemDesktop: banner_destaque_paramount,
      imagemMobile: banner_destaque_paramount_mobile,
      // linkDesktop: 'https://www.chippu.com.br/assinatura/paramount-plus',
      // linkMobile: 'https://www.chippu.com.br/assinatura/paramount-plus',
      linkDesktop:
        'https://www.chippu.com.br/assinatura/paramount-plus?utm_source=Destaque+Principal+Paramount+Plus+Chippu+Site&utm_medium=Site+Chippu',
      linkMobile:
        'https://www.chippu.com.br/assinatura/paramount-plus?utm_source=Destaque+Principal+Paramount+Plus+Chippu+Site&utm_medium=Site+Chippu',
    },
  ]);

  const [destaquesMobile] = useState<Destaque[]>([
    // {
    //   nome: 'Disney Plus',
    //   imagem: banner_promocional_disney,
    //   imagemMobile: banner_promocional_disney,
    //   id: 0,
    //   linkExterno:
    //     'https://disney-plus.chippu.com.br/?utm_source=Site-Chippu&utm_medium=Site-Chippu&utm_campaign=disney-marco&utm_content=card-site',
    //   produtoID: null,
    // },
    {
      nome: 'Disney Plus',
      imagem: banner_promocional_disney_cara_focinho,
      imagemMobile: banner_promocional_disney_cara_focinho,
      id: 0,
      linkExterno:
        'https://disney-plus.chippu.com.br/?utm_source=Site-Chippu&utm_medium=Site-Chippu&utm_campaign=disney-marco&utm_content=card-site',
      produtoID: null,
    },
    // {
    //   nome: 'Paramount',
    //   imagem: banner_promocional_paramount,
    //   imagemMobile: banner_promocional_paramount,
    //   id: 0,
    //   linkExterno:
    //     'https://disney-plus.chippu.com.br/?utm_source=Site-Chippu&utm_medium=Site-Chippu&utm_campaign=disney-marco&utm_content=card-site',
    //   produtoID: null,
    // },
    // {
    //   imagem: banner_promocional_bottom_hbo_max,
    //   imagemMobile: banner_promocional_bottom_hbo_max,
    //   linkExterno: 'https://www.chippu.com.br/assinatura/hbo-max',
    //   id: 1,
    //   nome: 'HBO Max',
    //   produtoID: null,
    // },
    // {
    //   nome: 'Game Pass Ultimate',
    //   imagem: banner_promocional_game_pass,
    //   imagemMobile: banner_promocional_game_pass,
    //   id: 1,
    //   linkExterno: 'https://xbox.chippu.com.br',
    //   produtoID: null,
    // },
    // {
    //   nome: 'Chippu Gift Card',
    //   imagem: banner_gift_card_mobile,
    //   imagemMobile: banner_gift_card_mobile,
    //   id: 1,
    //   linkExterno: null,
    //   produtoID: null,
    // },
    //   const [destaques] = useState<Array<Destaque> | null>([
    // {
    //   nome: 'Destaque Chippu Place',
    //   imagem:
    //     'https://chippu2-bucket.s3.us-east-1.amazonaws.com/MarketplaceDestaque/DESKTOP_CHIPPU_PLACE.png',
    //   imagemMobile:
    //     'https://chippu2-bucket.s3.us-east-1.amazonaws.com/MarketplaceDestaque/MOBILE_CHIPPU_PLACE.png',
    //   id: 1,
    //   linkExterno: 'https://chippu.com.br',
    //   produtoID: null,
    // },
    // {
    //   nome: 'Destaque Giftcards Gamescom',
    //   imagem:
    //     'https://d2d7ho1ae66ldi.cloudfront.net/ArquivoCombos/b40e1610-2600-11f0-aa7d-b1a1e9a25cc3/PLACE_GAMES_DESKTOP_2.png',
    //   imagemMobile:
    //     'https://d2d7ho1ae66ldi.cloudfront.net/ArquivoCombos/4911b6ac-2602-11f0-aa7d-b1a1e9a25cc3/gamescom+banner+place+teste.png',
    //   id: 2,
    //   linkExterno: 'https://chippu.com.br',
    //   produtoID: null,
    // },
    // ]);
  ]);

  const [destaquesDesktop] = useState<GaleriaImagem[]>([
    // {
    //   imagem: banner_imovision,
    //   abrirExterno: true,
    //   link: 'https://www.chippu.com.br/assinatura/imovision-1',
    // },
    // {
    //   imagem: banner_paramount,
    //   abrirExterno: true,
    //   link: 'https://www.chippu.com.br/assinatura/paramount-plus',
    // },
    // {
    //   imagem: banner_deezer,
    //   abrirExterno: true,
    //   link: 'https://www.chippu.com.br/assinatura/deezer',
    // },
    {
      imagem: banner_promocional_hbo_max,
      abrirExterno: true,
      link: 'https://www.chippu.com.br/assinatura/hbo-max?utm_source=Site-Chippu&utm_medium=Site-Chippu&utm_campaign=hbomax-regular&utm_content=banner-wide',
    },
  ]);

  const [bannersPromocionaisDesktop] = useState<GaleriaImagem[]>([
    // {
    //   imagem: banner_promocional_disney_cara_focinho,
    //   abrirExterno: true,
    //   link: 'https://disney-plus.chippu.com.br/?utm_source=Site-Chippu&utm_medium=Site-Chippu&utm_campaign=disney-promo-maio&utm_content=card-site',
    // },
    {
      imagem: banner_promocional_paramount,
      abrirExterno: true,
      link: 'https://www.chippu.com.br/assinatura/paramount-plus?utm_source=Site-Chippu&utm_medium=Site-Chippu&utm_campaign=paramountplus-regular&utm_content=card-site',
    },
    {
      imagem: banner_promocional_bottom_hbo_max,
      abrirExterno: true,
      link: 'https://www.chippu.com.br/assinatura/hbo-max?utm_source=Site-Chippu&utm_medium=Site-Chippu&utm_campaign=hbomax-regular&utm_content=card-site',
    },
  ]);

  const [produtos, setProdutos] = useState<Array<Produto> | null>(null);
  const [combos, setCombos] = useState<Array<Combo> | null>(null);
  const [assinaturas, setAssinaturas] = useState<Array<Produto> | null>(null);
  const [tiposDenunciaResenha, setTiposDenunciaResenha] = useState<
    MotivoDenunciaResenha[] | null
  >(null);
  const [playlistsUsuario, setPlaylistsUsuario] = useState<Playlist[] | null>(
    null,
  );
  const [favoritos, setFavoritos] = useState<Favoritos[] | null>(null);
  const [verDepois, setVerDepois] = useState<VerDepois[] | null>(null);
  const [emAltaStreaming, setEmAltaStreaming] =
    useState<Array<ConteudoRecomendacao> | null>(null);

  const [filmesEmCartaz, setFilmesEmCartaz] =
    useState<Array<ConteudoRecomendacao> | null>(null);

  const [carregandoCategorias, setCarregandoCategorias] = useState(false);
  const [carregandoProdutos, setCarregandoProdutos] = useState(false);
  const [carregandoCombos, setCarregandoCombos] = useState(false);
  const [carregandoAssinaturas, setCarregandoAssinaturas] =
    useState<boolean>(false);
  const [loadingTipoDenuncia, setLoadingTipoDenuncia] = useState(false);
  const [loadingListasUsuario, setLoadingListasUsuario] = useState(false);
  const [carregandoEmAltaStreaming, setCarregandoEmAltaStreaming] =
    useState(false);
  const [carregandoFilmesEmCartaz, setCarregandoFilmesEmCartaz] =
    useState(false);

  const categoriaTodos: Categoria = {
    cor: '',
    icone: '',
    id: '',
    nome: 'Todos',
    marketPlaceCategoriaID: '',
  };

  async function recuperarCategorias() {
    if (categorias?.length || carregandoCategorias) return;
    setCarregandoCategorias(true);
    try {
      const categoriasFromServer = await getCategorias();
      setCategorias([categoriaTodos, ...(categoriasFromServer ?? [])]);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      /*empty*/
    } finally {
      setCarregandoCategorias(false);
    }
  }

  // async function recuperarDestaques() {
  //   if (destaques?.length) return;
  //   const destaquesFromServer = await getDestaques();
  //   setDestaques(destaquesFromServer);
  // }

  async function recuperarProdutos() {
    if (produtos?.length || carregandoProdutos) return;
    try {
      setCarregandoProdutos(true);
      const produtosFromServer = await listarProdutos({
        filtros: 'somenteBeneficio == false && assinatura == false',
      });
      setProdutos(produtosFromServer);

      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      /*empty*/
    } finally {
      setCarregandoProdutos(false);
    }
  }

  async function recuperarAssinaturas() {
    if (assinaturas?.length || carregandoAssinaturas) return;
    setCarregandoAssinaturas(true);
    try {
      const assinaturasFromServer = await listarProdutos({
        filtros: 'assinatura == true',
      });
      setAssinaturas(assinaturasFromServer);

      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      /*empty*/
    } finally {
      setCarregandoAssinaturas(false);
    }
  }

  const { status } = useSession();

  async function recuperarTiposDenunciaResenha() {
    if (
      tiposDenunciaResenha?.length ||
      loadingTipoDenuncia ||
      status !== 'authenticated'
    )
      return;
    setLoadingTipoDenuncia(true);
    try {
      const tiposDenunciaFromServer = await listarTiposDenunciaResenha();
      setTiposDenunciaResenha(tiposDenunciaFromServer.dados.lista);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      /*empty*/
    } finally {
      setLoadingTipoDenuncia(false);
    }
  }

  async function recuperarListasUsuario(
    props: ArgumentosListarPlaylistsUsuario,
  ) {
    if (loadingListasUsuario || status !== 'authenticated') return;
    setLoadingListasUsuario(true);
    try {
      const playlistsUsuarioFromServer = await listarPlaylistsUsuario(props);
      setPlaylistsUsuario(playlistsUsuarioFromServer.dados.lista);
      setFavoritos(playlistsUsuarioFromServer.dados.favoritos);
      setVerDepois(playlistsUsuarioFromServer.dados.verDepois);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      /*empty*/
    } finally {
      setLoadingListasUsuario(false);
    }
  }

  async function recuperarCombos(filtros?: string) {
    if (combos?.length || carregandoCombos) return;
    setCarregandoCombos(true);
    try {
      const combosFromServer = await listarCombos(filtros ? { filtros } : {});
      setCombos(combosFromServer);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      /*empty*/
    } finally {
      setCarregandoCombos(false);
    }
  }

  async function recuperarEmAltaStreaming() {
    try {
      if (emAltaStreaming?.length || carregandoEmAltaStreaming) return;
      setCarregandoEmAltaStreaming(true);
      const conteudosEmAltaStreaming = await listarConteudosEmAltaStreaming();
      setEmAltaStreaming(conteudosEmAltaStreaming);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      /*empty*/
    } finally {
      setCarregandoEmAltaStreaming(false);
    }
  }

  async function recuperarFilmesEmCartaz() {
    try {
      if (filmesEmCartaz?.length || carregandoFilmesEmCartaz) return;
      setCarregandoFilmesEmCartaz(true);
      const conteudosFilmesEmCartaz = await listarFilmesEmCartaz();
      setFilmesEmCartaz(conteudosFilmesEmCartaz);

      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      /*empty*/
    } finally {
      setCarregandoFilmesEmCartaz(false);
    }
  }

  return (
    <HomePageDataContext.Provider
      value={{
        categorias,
        setCategorias,
        destaquesMobile,
        destaquesDesktop,
        // setDestaques,
        produtos,
        setProdutos,
        combos,
        setCombos,
        assinaturas,
        carregandoAssinaturas,
        setAssinaturas,
        recuperarCategorias,
        // recuperarDestaques,
        recuperarProdutos,
        recuperarCombos,
        recuperarAssinaturas,
        categoriaTodos,
        recuperarTiposDenunciaResenha,
        recuperarListasUsuario,
        tiposDenunciaResenha,
        playlistsUsuario,
        favoritos,
        verDepois,
        loadingListasUsuario,
        recuperarEmAltaStreaming,
        emAltaStreaming,
        carregandoEmAltaStreaming,
        recuperarFilmesEmCartaz,
        filmesEmCartaz,
        carregandoFilmesEmCartaz,
        bannersCarousel,
        bannersPromocionaisDesktop,
      }}
    >
      {children}
    </HomePageDataContext.Provider>
  );
};
